
import { Vue, Component } from "vue-property-decorator";
import dayjs from "dayjs";
@Component({
  name: "assess",
})

export default class assess extends Vue {
	
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private totalNum = 0;
  private form = {};

  private mounted() {
   
	this.getQualityTestCheckList(1);
  }
  
  private getQualityTestCheckList(num:number){
	  
	  let datas = [];
	  this.pageNo = num;
	  let paramter = {
	  	'pageNum':this.pageNo,
	  	'pageSize':this.pageSize
	  };
	  console.log('---',paramter);
	  this.$http.get("producteval/list", {params:paramter}).then((res: any) => {
	  	      this.totalNum = res.data.data.total;
	  	  	  datas = res.data.data.data;
			      this.pageNo = num;
			      this.pageSize = res.data.data.pageSize;
	  	  	  this.tableData = datas;
	  	      console.log("品测内容",this.tableData);
	  });
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
	
	this.getQualityTestCheckList(this.pageNo);
  }
  private handlePublishStatusChange(index,row){
    console.log(row);
  }
  private onSubmit() {
    console.log(this.form);
  }
  private handleNoDetail(index,row) {
	  
	  let approveTag = row.approveTag;
	  this.$router.push({path: '/Community/checkDetail',query:row})
  }
}
